import { render, staticRenderFns } from "./MusicPlaylist.vue?vue&type=template&id=325d4fd5&scoped=true&"
import script from "./MusicPlaylist.vue?vue&type=script&lang=js&"
export * from "./MusicPlaylist.vue?vue&type=script&lang=js&"
import style0 from "./MusicPlaylist.vue?vue&type=style&index=0&id=325d4fd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325d4fd5",
  null
  
)

export default component.exports